import type { Data } from '@puckeditor/core'
import { Render } from '@puckeditor/core'
import * as React from 'react'

import { puckConfig } from '@/configs/puck-config'

interface NonFsdsPuckPageContentProps {
  puckData: Data | null
  fallback: React.ReactNode
}

/** Renders published Puck sections or a static fallback when no template is published. */
export default function NonFsdsPuckPageContent({ puckData, fallback }: NonFsdsPuckPageContentProps) {
  if (!puckData) {
    return <>{fallback}</>
  }

  return <Render config={puckConfig} data={puckData} />
}
